
import React, { useEffect } from 'react';
import { Box, Flex, Text, Spinner } from '@chakra-ui/react';
import { Global, css } from '@emotion/react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSurveyStats, selectSurveyStats } from '../../redux/slices/surveyStatsSlice';

const BlinkingDot = ({ count }) => (
  <>
    <Global
      styles={css`
        @keyframes blinker {
          50% {
            opacity: 0;
          }
        }
      `}
    />
    <Box
      ml={2}
      w="28px"
      h="28px"
      borderRadius="full"
      bg="red.500"
      color="white"
      fontSize="xs"
      fontWeight="bold"
      animation="blinker 3s linear infinite"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      {count}
    </Box>
  </>
);

const PendingSurveysLabel = () => {
  const dispatch = useDispatch();
  const { data, loading } = useSelector(selectSurveyStats);

  useEffect(() => {
    dispatch(fetchSurveyStats());
  }, [dispatch]);

  const pendingCount = data?.pending ?? null;

  return (
    <Flex align="center">
      <Text>Pending Surveys</Text>
      {pendingCount === null || loading ? (
        <Spinner size="xs" ml={2} />
      ) : (
        pendingCount > 0 && <BlinkingDot count={pendingCount} />
      )}
    </Flex>
  );
};

export default PendingSurveysLabel;
